export const concertCacheKey = (eventKey: string, invitationId?: string) =>
  `concert-${eventKey}-${invitationId ?? ''}`;

export const eventCacheKey = (eventKey: string, invitationId?: string) =>
  `event-${eventKey}-${invitationId ?? ''}`;

/** Returns the first matching cached key shape — concerts store under 'concert-', events under 'event-'. */
export const anyCacheKey = (eventKey: string, invitationId?: string): [string, string] => [
  concertCacheKey(eventKey, invitationId),
  eventCacheKey(eventKey, invitationId),
];
